<template v-if="tab === 'about'">
  <li class="headline">
    {{ t('menu.tabs.about') }}
  </li>
  <li @click="grimoire.toggleModal('gameState')">
    {{ t('menu.gameState') }}
    <em><font-awesome-icon icon="file-code" class="fa fa-file-code" /></em>
  </li>
  <li>
    <a href="https://discord.gg/gD3AB8qCrw" target="_blank">
      {{ t('menu.discord') }}
    </a>
    <em>
      <a href="https://discord.gg/gD3AB8qCrw" target="_blank">
        <font-awesome-icon :icon="['fab', 'discord']" />
      </a>
    </em>
  </li>
</template>

<script setup lang="ts">
import {
  useGrimoireStore,
  useLocaleStore,
} from "@/stores";

const grimoire = useGrimoireStore();
const locale = useLocaleStore();
const t = locale.t;
</script>

<style lang="scss" src="./Menu.scss" scoped></style>
